import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCFDNotPairedDialog } from '../Selectors'
import { setCFDNotPairedDialog } from '../ActionCreators'
import ConfirmModalV2 from '../../components/ConfirmModalV2'

export const VNCFDNotPairedDialog = () => {
  const isOpen = useSelector((state) => getCFDNotPairedDialog(state))
  const dispatch = useDispatch()

  if (!isOpen) {
    return null
  }

  return (
    <ConfirmModalV2
      open={isOpen}
      singleButtonOnly
      headerText={'Card Reader Communication Error.'}
      onButtonTwoClick={() => dispatch(setCFDNotPairedDialog(false))}
      subtext={'Reconnect Card Reader and Retry.'}
      buttonTwoText={'OKAY'}
    />
  )
}
